export const DEFAULT_UNSUPPORTED_SCM_URL_FORMATS_KEY = 'default'
